module.exports = __webpack_public_path__ + "img/icon-invite.f68894f6.svg";